import EventEmitter from 'events'

export default class Realizations {
    constructor(el, options) {
        // Check view element
        if (el instanceof HTMLElement) {
            this.el = el
        } else {
            this.el = document.querySelector(el)
        }
        if (!this.el || !this.el.querySelector('.views-exposed-form')) {
            console.warn('No valid view found. Sorry bro.')
            return false
        }
        // Init
        this.form = this.el.querySelector('.views-exposed-form')
        this.rowsContainer = this.el.querySelector('.m-view-realizations_api_rows')
        this.values = {}
        this.emitter = new EventEmitter()

        // Listen select
        this.listenSelectTags()
    }
    listenSelectTags() {
        const selects = this.el.querySelectorAll('.m-realizations_select')
        selects.forEach(select => {
            select.addEventListener('change', e => {
                if(select.value != 'reset') {
                    this.values[select.id] = select.value
                } else {
                    this.values[select.id] = ''
                }
                // Add loading
                this.el.classList.add(`-loading`)
                // Get URL
                const url = this.getURL()
                // Append DOM
                this.appendDOM(url, true)
            })
        })
    }
    getURL() {
        let params = ''
        for (const name in this.values) {
            if(params !== '')
                params += '&'
            params += `${name}=${this.values[name]}`
        }
        return `${this.form.action}?${params}`
    }
    appendDOM(url, reset = false) {
        // Send request
        const request = new XMLHttpRequest()
        request.open('GET', url)
        request.responseType = 'document'
        request.send()
        request.onload = () => {
            const dom = request.response
            // Get DOM
            this.rowsContainer.innerHTML = ''
            this.rowsContainer.append(dom.querySelector('.m-view-realizations'))
            // Set min height
            if(this.el.querySelector('.m-realizations_visual')) {
                this.rowsContainer.style.minHeight = `${this.el.querySelector('.m-realizations_visualsLift').offsetHeight}px`
            } else {
                this.rowsContainer.style.minHeight = 'initial'
            }
            // Remove loading
            this.el.classList.remove(`-loading`)
            // Change event
            this.emitter.emit('change')
        }
    }
}